export default [
  {
    path: '/fishermen',
    name: 'fishermen',
    component: () => import('@/views/pages/fisherman/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.fishermen',
      resource: 'fisherman',
      action: 'list',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          active: true,
        },
      ],
    },
  },
  {
    path: '/fishermen/import',
    name: 'fishermen-import',
    component: () => import('@/views/pages/fisherman/Import.vue'),
    meta: {
      pageTitle: 'breadcrumb.fishermen',
      resource: 'fisherman',
      action: 'edit',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          to: '/fishermen',
          active: false,
        },
        {
          text: 'breadcrumb.import',
          active: true,
        },
      ],
    },
  },
  {
    path: '/fishermen/modify/:id',
    name: 'modify-fisherman',
    component: () => import('@/views/pages/fisherman/Modify.vue'),
    meta: {
      pageTitle: 'breadcrumb.fishermen',
      resource: 'fisherman',
      action: 'edit',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          to: '/fishermen',
          active: false,
        },
        {
          text: 'breadcrumb.modify',
          active: true,
        },
      ],
    },
  },
]
